import * as React from 'react';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';
import { connect } from "react-redux";

import { DataLocalService } from 'src/core/services/data-local.service';
import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { ObjectUtils } from 'src/core/utils/object';
import { FormatService } from 'src/core/services/format.service';

interface PropsFromState {
	currencies: CurrencySummary[];
}

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	occupancyColumns: OccupancyColumn[];
	productPriceConfigs: ItineraryDateProductPriceConfig[];
	sellCurrencyIsoCode: string;
	products: TourItineraryProductItem[];
	itinerary: TourItineraryItem;
}

@observer
class TourItineraryDatePriceSummary extends React.Component<Props & PropsFromState, {}> {
	@resolve
	private formatService: FormatService;

	render(): React.ReactNode {
		const { occupancyColumns, productPriceConfigs, currencies, mode, setBusy, sellCurrencyIsoCode, itinerary } = this.props;
		const formatCurrency = currencies.find(m => m.iso3Name === sellCurrencyIsoCode).format;
		const columns: Column[] = [{
			title: 'Service',
			key: 'itineraryServiceName',
			dataIndex: 'itineraryServiceName'
		},
		...occupancyColumns.map(m => ({
			title: m.name.toUpperCase(),
			key: m.name,
			children: [
				{
					title: 'Sell',
					key: `sell-${m.name}`,
					editable: (_, record) => {
						const value = record[m.name] != null ? ObjectUtils.round(record[m.name].sell) : 0;
						return this.formatService.toString('currency', value, formatCurrency);
					}
				},
				{
					title: 'Margin',
					key: `margin-${m.name}`,
					editable: (_, record) => {
						if (record[m.name] == null) {
							return 0;
						}

						const profit = (record[m.name].sell - record[m.name].cost);
						const margin = 100 * profit / (record[m.name].sell || 1);
						const profitFormatted = this.formatService.toString('currency', ObjectUtils.round(profit), formatCurrency);
						return `${ObjectUtils.round(margin)}% (${profitFormatted})`;
					}
				}
			]
		}))];

		const service = Object.assign({
			itineraryServiceName: itinerary.productServiceTypeDisplayName
		}, ...occupancyColumns.map(m => {
			let cost = 0;
			let sell = 0;
			for (let product of productPriceConfigs) {
				const occupancyPrice = product.occupanciesPrice.find(p => p.occupancyName === m.name);
				if (occupancyPrice != null) {
					cost += occupancyPrice.cost;
					sell += occupancyPrice.sell;
				}
			}

			return {
				[m.name]: {
					sell,
					cost
				}
			};
		})
		);
		const dataSet = new DataLocalService<any>([service]);

		return (
			<DataTableView
				rowKey={(m) => m.itineraryServiceName}
				model={dataSet}
				columns={columns}
				mode={mode}
				setBusy={setBusy}
				hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination | ToolbarVisibility.hideFooter}
				selection={false}
			/>
		);
	}
}

const mapStateToProps = (state: IApplicationState): PropsFromState => {
	return {
		currencies: state.currencies,
	};
};

const connected = connect(
	mapStateToProps,
)(TourItineraryDatePriceSummary);
export { connected as TourItineraryDatePriceSummary };



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-price-summary.tsx